import { useSelector } from 'react-redux';
import { NAMESPACE } from './constants';
export const useIsPlatformJourneyEnabled = () => {
    const { isPlatformJourneyEnabled } = useSelector((state) => {
        const platformJourney = state[NAMESPACE];
        return platformJourney;
    });
    return isPlatformJourneyEnabled;
};
//# sourceMappingURL=useIsPlatformJourneyEnabled.js.map